import React, { useState } from "react";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  IconButton,
  Button,
  Grid,
  Typography,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import AddIcon from "@material-ui/icons/Add";
import SaveIcon from "@material-ui/icons/Save";

function opcionesIniciales(valorInicial) {
  if (Array.isArray(valorInicial) && valorInicial.length > 0) {
    return valorInicial.map((o) => ({
      texto: o.texto || o.valor || "",
      oculto: o.oculto === true,
    }));
  }
  return [{ texto: "", oculto: false }];
}

export default function SelectOptionsEditor({ valorInicial, onGuardar }) {
  const [opciones, setOpciones] = useState(() => opcionesIniciales(valorInicial));

  function actualizarTexto(i, texto) {
    setOpciones((prev) => prev.map((o, idx) => (idx === i ? { ...o, texto } : o)));
  }

  function actualizarOculto(i, oculto) {
    setOpciones((prev) => prev.map((o, idx) => (idx === i ? { ...o, oculto } : o)));
  }

  function agregarOpcion() {
    setOpciones((prev) => [...prev, { texto: "", oculto: false }]);
  }

  function eliminarOpcion(i) {
    setOpciones((prev) => prev.filter((_, idx) => idx !== i));
  }

  function guardar() {
    const limpio = opciones
      .filter((o) => o.texto && o.texto.trim() !== "")
      .map((o) => ({ texto: o.texto.trim(), valor: o.texto.trim(), oculto: o.oculto === true }));
    onGuardar(limpio);
  }

  return (
    <div style={{ margin: "10px 0" }}>
      <Typography variant="subtitle2" gutterBottom>
        Opciones del campo
      </Typography>
      {opciones.map((opcion, i) => (
        <Grid container key={i} spacing={1} alignItems="center" style={{ marginBottom: 6 }}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              size="small"
              variant="outlined"
              label={"Opción " + (i + 1)}
              value={opcion.texto}
              onChange={(e) => actualizarTexto(i, e.target.value)}
            />
          </Grid>
          <Grid item xs={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={opcion.oculto === true}
                  onChange={(e) => actualizarOculto(i, e.target.checked)}
                />
              }
              label="Oculto"
            />
          </Grid>
          <Grid item xs={2}>
            <IconButton
              onClick={() => eliminarOpcion(i)}
              disabled={opciones.length <= 1}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      ))}
      <Button
        size="small"
        startIcon={<AddIcon />}
        onClick={agregarOpcion}
        style={{ marginRight: 10 }}
      >
        Agregar opción
      </Button>
      <Button
        size="small"
        variant="contained"
        color="primary"
        startIcon={<SaveIcon />}
        onClick={guardar}
      >
        Guardar opciones
      </Button>
    </div>
  );
}
